export default __webpack_public_path__ + "static/media/home.341de89a.png";